<ion-content class="ion-padding-start ion-padding-end" fullscreen>
  <!-- Page header -->
  <ion-header class="shadow-none ion-no-margin bg-transparent" [ngClass]="isMobileApp() ? '' : ''">
    <ion-toolbar class="ion-no-padding">
      <!-- Page title text -->
      <ion-text class="page-title ion-no-margin font-family-bold pb-0">
        {{ 'REQUEST_SERVICE' | translate }}
      </ion-text>
    </ion-toolbar>
  </ion-header>

  <!-- Vehicle registration header component -->
  <app-vehicle-registration-header>
  </app-vehicle-registration-header>

  <!-- Main content wrapper -->
  <div class="ion-margin-bottom">

    <!-- Draft booking concern card shown when concern exists and current component is MENU -->
    @if(concernCount() != 0 && currentComponent() == 'MENU')
    {
    <ion-card (click)="redirectBookingConcern()" (keydown.enter)="redirectBookingConcern()"
      class="CSAT-card ion-no-margin ion-margin-top ion-margin-bottom ion-padding  cursor-pointer">
      <!-- Draft booking text with dynamic concern count -->
      <ion-text class="dark-color">
        View current draft booking ({{concernText()}})
      </ion-text>
    </ion-card>
    }

    <!-- Service provider component rendered when currentComponent is SERVICE_PROVIDER -->
    @if (currentComponent() == 'SERVICE_PROVIDER') {
    <app-service-provider [icnNo]="icnNo()" (valueChange)="btnClicked()" [serviceProviderData]="providerData()"
      (fastFit)="handleFastFit($event)">
    </app-service-provider>
    }

    <!-- Support topics cards rendered when currentComponent is MENU -->
    @if(currentComponent() == 'MENU')
    {
    <!-- Loop through grouped catalog data -->
    @for (item of groupedCatalogData(); track $index) {
    <app-support-topics-card [item]="item" [description]="description()" [title]="title()"
      (headerClick)="catalogDataHeaderClicked()" (emitCatalogId)="getServiceCatalog($event)">
    </app-support-topics-card>
    }
    }

    <!-- Vendor service list rendered when currentComponent is VENDOR_SERVICE_LIST -->
    @if(currentComponent() == 'VENDOR_SERVICE_LIST')
    {
    <app-vendor-service-list [isVendorInfo]="isVendorInfoAvailable()" [serviceProviderInfo]="serviceProviderInfo()"
      (valueChange)="btnClicked()" [icnNo]="icnNo()" [vendoreService]="providerData()">
    </app-vendor-service-list>
    }

  </div>
</ion-content>